import type { SeriesClassificationSummary } from 'generated/graphql';

type Classifications = Nullable<ReadonlyArray<Nullable<SeriesClassificationSummary>>>;

// Returns true when any classification's anatomic focus display name matches one of `foci`. Kept as
// a pure function so it can be evaluated against either an imaging provider's captured classifications
// or a reactively-hydrated series' classifications (see useShouldAlignChestWallWithSideOfViewport).
export function classificationsIncludeFoci(
  classifications: Classifications,
  foci: string[]
): boolean {
  if (classifications == null) return false;

  const displayNames = classifications.flatMap(
    (classification) =>
      classification?.seriesCriteria?.anatomic_focus?.map((focus) => focus?.display_name ?? '') ??
      []
  );

  return displayNames.some((name) => foci.includes(name));
}
